import * as React from 'react';
import { cianIcon } from './icon_cian';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NoOffers = function NoOffers() {
  return /*#__PURE__*/_jsx("div", {
    className: styles['no_offers'],
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['no_offers-content'],
      children: [cianIcon, /*#__PURE__*/_jsx("span", {
        className: styles['no_offers-text'],
        children: "\u041D\u0435\u0442 \u043F\u043E\u0445\u043E\u0436\u0438\u0445 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u043D\u0430 \u0434\u0440\u0443\u0433\u0438\u0445 \u044D\u0442\u0430\u0436\u0430\u0445"
      })]
    })
  });
};